<template>
  <el-dialog title="Perguntas do Formulário" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="35%">
    <el-form size="small" :model="formulario" label-position="top" ref="perguntasForm">
      <el-form-item v-for="(pergunta, index) in formulario.perguntasFormulario" :label="pergunta.texto" :key="pergunta.id" :prop="'perguntasFormulario.' + index + '.resposta'">
        <el-input v-model="pergunta.resposta"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="gerarFormulario()" type="primary" round class="btn-box-shadow">Gerar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    visibility: Boolean,
    formulario: Object,
    aluguel: Object,
    venda: Object,
    imovel: Object
  },
  data() {
    return {
      nome: ""
    };
  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"]),
      ...mapActions("alugueisContratosStore", [
      "gerarFormularioAluguel"
    ]),
    ...mapActions("vendasContratosStore", [
      "gerarFormularioVenda"
    ]),
    ...mapActions("vendasImoveisStore", [
      "gerarFormularioImovel"
    ]),
    gerarFormulario() {
      this.showLoading();

      if (this.aluguel !== undefined && this.aluguel.id != 0) {
        this.formulario.aluguel = this.aluguel;

        this.gerarFormularioAluguel(this.formulario)
          .then(resultado => {
            window.open(resultado.mensagem, "_blank");
            this.hideLoading();
            this.fechar();
          })
          .catch(() => {
            this.$message.error("Ocorreu um erro.");
            this.hideLoading();
          });
      }

      if (this.venda !== undefined && this.venda.id != 0) {
        this.formulario.venda = this.venda;

        this.gerarFormularioVenda(this.formulario)
          .then(resultado => {
            window.open(resultado.mensagem, "_blank");
            this.hideLoading();
            this.fechar();
          })
          .catch(() => {
            this.$message.error("Ocorreu um erro.");
            this.hideLoading();
          });
      }

      if (this.imovel !== undefined && this.imovel.id != 0) {
        this.formulario.imovel = this.imovel;

        this.gerarFormularioImovel(this.formulario)
          .then(resultado => {
            window.open(resultado.mensagem, "_blank");
            this.hideLoading();
            this.fechar();
          })
          .catch(() => {
            this.$message.error("Ocorreu um erro.");
            this.hideLoading();
          });
      }
    },

    fechar() {
      this.$emit("close");
    }
  }
};
</script>

